import en from './translations/en.json'
import ja from './translations/ja.json'

export default { en, ja }
